import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Paper,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { read, utils, writeFile } from "xlsx";
import { send } from "../../SendRequest";
import { isNotEmpty } from "../../Utils";

const useStyles = makeStyles({
    failOrg: {
        color: "red",
        marginBottom: "10px",
        borderBottom: "1px solid #c5c3c3",
        paddingBottom: "5px",
    },
    noneOrg: {
        textAlign: "center",
        padding: "80px !important",
        marginBottom: "15px",
        borderBottom: "1px solid black",
    },
    currnetOrg: {
        padding: "10px 0",
        marginBottom: "20px",
        borderBottom: "1px solid black",
    },
    successOrg: {
        marginBottom: "8px",
        borderBottom: "1px solid #c5c3c3",
        paddingBottom: "8px",
    },
});

function ParameterTemplate102({ defaultValues, setValue }) {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const classes = useStyles();
    const initOrgList = defaultValues?.delegatationOrgList;
    const [orgList, setOrgList] = useState([]);
    const [failOrgList, setFailOrgList] = useState([]);
    const [successOrgList, setSuccessOrgList] = useState(initOrgList);
    const [uploadOrgFailOpen, setUploadOrgFailOpen] = useState(false);
    const [copySuccessOpen, setCopySuccessOpen] = useState(false);
    const [copyFailOpen, setCopyFailOpen] = useState(false);

    const readUploadFile = (event) => {
        event.preventDefault();
        if (event.target?.files?.length > 0) {
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = read(data, { type: "array" });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
                const nameList = jsonData.map((row) => row[0]);
                let failList = [],
                    successList = [];
                // Skip header row at json[0] if not needed in nameList.
                nameList.forEach((_name) => {
                    const name = String(_name);
                    const matchingOrg = orgList.find((org) => {
                        return (
                            org?.name
                                ?.replace(/^\s+|\s+$/g, "")
                                .toLowerCase() ===
                            name?.replace(/^\s+|\s+$/g, "").toLowerCase()
                        );
                    });
                    isNotEmpty(matchingOrg)
                        ? successList.push(matchingOrg)
                        : isNotEmpty(name) && failList.push(name);
                });
                setFailOrgList(failList);
                successList = successList.map((org) => {
                    return { id: org?.orgID, name: org?.name };
                });
                setSuccessOrgList(successList);
                setValue("delegatationOrgList", successList);
            };
            reader.readAsArrayBuffer(file);
            event.target.value = "";
        }
    };

    useEffect(() => {
        const option = {
            url: `${Config.CONTENT_PATH}/organizations/ssloOrganizationList`,
        };
        dispatch(send("GET", option))
            .then((response) => response.json())
            .then((data) => {
                setOrgList(data);
            });
    }, []);

    useEffect(() => {
        if (failOrgList.length > 0) {
            setUploadOrgFailOpen(true);
        } else {
            setUploadOrgFailOpen(false);
        }
    }, [failOrgList]);

    const handleSavedClose = () => {
        setFailOrgList([]);
    };

    const handleCopyClose = () => {
        const copyText = document?.getElementById(
            "upload_org_fail_copy_body"
        )?.innerText;
        if (copyText) {
            copyToClipboard(copyText);
        } else {
            setCopyFailOpen(true);
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(function () {
                console.log("Text copied to clipboard");
                setCopySuccessOpen(true);
            })
            .catch(function (err) {
                console.error("Failed to copy text: ", err);
                setCopyFailOpen(true);
            });
    };

    const downloadExcel = () => {
        let sheetData = [];
        /*if (isNotEmpty(successOrgList)) {
            sheetData = successOrgList?.map((org) => {
                return [org?.name];
            });
        } else {*/
        sheetData = orgList?.map((org) => {
            return [org?.name];
        });
        //}
        const jsonWorkSheet = utils.aoa_to_sheet(sheetData);
        const workBook = {
            SheetNames: ["NGO"],
            Sheets: {
                ["NGO"]: jsonWorkSheet,
            },
        };
        const today = moment().format("yyyy_MM_DD");
        return writeFile(workBook, `NGO_${today}.xlsx`);
    };

    function FailUploadDialog(open) {
        return (
            <React.Fragment>
                <Dialog
                    aria-labelledby="simple-dialog-title"
                    open={open}
                    PaperProps={{
                        style: { minWidth: "450px", minHeight: "350px" },
                    }}
                >
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.uploadOrgFail")}
                    </DialogTitle>
                    <DialogContent id="upload_org_fail_copy_body">
                        {failOrgList?.map((orgName) => (
                            <Typography
                                key={orgName?.id}
                                className={classes.failOrg}
                            >
                                {orgName}
                            </Typography>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleCopyClose}
                            color="success"
                        >
                            <b>{t("common.portal.copyOrg")}</b>
                        </Button>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function FailCopyDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogContent>{t("common.portal.copyFail")}</DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={() => {
                                setCopyFailOpen(false);
                            }}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function SuccessCopyDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogContent>
                        {t("common.portal.copySuccess")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={() => {
                                setCopySuccessOpen(false);
                            }}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    return (
        <Paper style={{ padding: "20px" }}>
            <Grid container spacing={5} alignItems="center">
                <Grid
                    item
                    xs={12}
                    className={
                        isNotEmpty(successOrgList)
                            ? classes.currnetOrg
                            : classes.noneOrg
                    }
                >
                    <Typography style={{ marginBottom: "5px" }}>
                        {t("common.portal.currnetOrg")}
                    </Typography>
                    <Box style={{ maxHeight: "300px", overflowY: "auto" }}>
                        {isNotEmpty(successOrgList) &&
                            successOrgList.map((org) => (
                                <Typography
                                    key={org.id}
                                    className={classes.successOrg}
                                >
                                    {org?.name}
                                </Typography>
                            ))}
                    </Box>
                    {!isNotEmpty(successOrgList) && t("common.portal.noneOrg")}
                </Grid>
                <Grid
                    item
                    xs={6}
                    style={{
                        textAlign: "center",
                        borderRight: "1px solid black",
                    }}
                >
                    <Box mb={4}>
                        <Typography>
                            {t("common.portal.downloadCurrnetOrg")}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="outlined"
                            component="label"
                            onClick={downloadExcel}
                        >
                            {t("common.download")}
                        </Button>
                    </Box>
                </Grid>

                <Grid item xs={6} style={{ textAlign: "center" }}>
                    <Box mb={4}>
                        <Typography>
                            {t("CCCUpdatePage.uploadExcelFile")}
                        </Typography>
                    </Box>
                    <Box>
                        <Button variant="outlined" component="label">
                            {t("common.fileUploadMsg")}
                            <input
                                hidden
                                accept=".xls,.xlsx"
                                type="file"
                                onChange={readUploadFile}
                            />
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            {uploadOrgFailOpen ? FailUploadDialog(uploadOrgFailOpen) : null}
            {copyFailOpen ? FailCopyDialog(copyFailOpen) : null}
            {copySuccessOpen ? SuccessCopyDialog(copySuccessOpen) : null}
        </Paper>
    );
}

export default ParameterTemplate102;
